/* eslint import/prefer-default-export: off */
import '../stylesheets/application.scss';

import Sittercity from './sittercity';
import App from '../apps/App.vue';
import { setupApollo } from '../lib/apollo_setup';
import { redirectIfNotOnboarded } from '../lib/sitterOnboarding/sitterOnboardingState';

import router from '../router';
import store from '../store';

export const apolloProvider = setupApollo();

document.addEventListener('DOMContentLoaded', async () => {
  const appNode = document.getElementById('app-rerouted');

  if (appNode === null) {
    console.log('Continuing to entrypoints'); // eslint-disable-line no-console
  } else {
    appNode.innerHTML = '<div style="text-align: center; padding: 50px; font-size: 18px;">Loading...</div>';

    // Check if this is a route that should skip authentication
    const currentPath = window.location.pathname;
    const isDeactivationConfirmation = currentPath === '/account/deactivation/confirmation';
    const isBhBenefits = currentPath.startsWith('/bh-benefits') && currentPath !== '/bh-benefits/upgrade';

    if (!isDeactivationConfirmation && !isBhBenefits) {
      try {
        await store.dispatch('account/fetchAccountData');

        // Check sitter onboarding state after account data is fetched
        const account = store.getters['account/getAccount'];
        if (account?.isSitter()) {
          // Skip onboarding check if already on onboarding routes
          const isOnboardingRoute =
            currentPath.startsWith('/sitter/signup') ||
            currentPath.startsWith('/sitter/verify_identity') ||
            currentPath.startsWith('/sitter/background_check') ||
            currentPath.startsWith('/sitter/complete');

          if (!isOnboardingRoute) {
            try {
              const didRedirect = await redirectIfNotOnboarded(apolloProvider, account);
              if (didRedirect) {
                return; // This prevents user from seeing a "blink" after loading
              }
            } catch (error) {
              console.error('Sitter onboarding check failed, redirecting to first step:', error);
              // Fallback: redirect to first onboarding step
              window.location.assign('/sitter/signup/address');
              return; // Don't mount the app
            }
          }
        }
      } catch (error) {
        console.error('Failed to fetch account data', error);
      }
    }

    new Sittercity({
      router,
      store,
      apolloProvider,
      name: 'Sittercity',
      propsData: {
        skipSegmentPageEvent: true, // afterEach hook handles Segment in SPA mode (see router/index.ts)
      },
      render(createElement) {
        return createElement(App);
      },
    }).$mount('#app-rerouted');
  }
});
